import { WebPlugin } from '@capacitor/core';
export class PrinterWeb extends WebPlugin {
    async print() {
        console.log('Not supported web browsers!');
        return Promise.reject('Printer plugin is not supported on web.');
    }
}
//# sourceMappingURL=web.js.map